import React from "react";
import { split, find, includes } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEarthEurope as faRegularEarthEurope,
  faInbox as faRegularInbox,
  faFolderOpen as faRegularFolderOpen,
  faCalendarDay as faRegularCalendarDay,
  faTable as faRegularTable,
  faCompass as faRegularCompass,
  faBullhorn as faRegularBullhorn,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faEarthEurope as faDuotoneEarthEurope,
  faInbox as faDuotoneInbox,
  faFolderOpen as faDuotoneFolderOpen,
  faCalendarDay as faDuotoneCalendarDay,
  faTable as faDuotoneTable,
  faCompass as faDuotoneCompass,
  faBullhorn as faDuotoneBullhorn,
} from "@fortawesome/pro-duotone-svg-icons";
import { Item } from "../../../@types/searchBar";

const MODULE_WHITELIST = [
  "activities",
  "messages",
  "files",
  "appointments",
  "calendars",
  "pages",
  "items",
  "channels",
];

function getModule(module: string) {
  switch (module) {
    case "activitystreams":
      return "activities";
    case "calendars":
      return "appointments";
    case "apps":
      return "items";
    case "search":
      return getModuleFromQueryParams();
    default:
      return module;
  }
}

function getModuleFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const module = urlParams.get("module");

  // needed to make typescript happy
  if (!module) return;

  if (includes(MODULE_WHITELIST, module)) {
    return module;
  }
}

export function getIcon({ module }: Item, duo?: boolean) {
  switch (module) {
    case "activities":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneEarthEurope : faRegularEarthEurope}
        />
      );
    case "messages":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneInbox : faRegularInbox}
        />
      );
    case "files":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneFolderOpen : faRegularFolderOpen}
        />
      );
    case "appointments":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneCalendarDay : faRegularCalendarDay}
        />
      );
    case "items":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneTable : faRegularTable}
        />
      );
    case "channels":
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneBullhorn : faRegularBullhorn}
        />
      );
    default:
      return (
        <FontAwesomeIcon
          className={""}
          icon={duo ? faDuotoneCompass : faRegularCompass}
        />
      );
  }
}

export function generateItems() {
  const location = split(window.location.pathname, "/");

  let module = getModule(location[1]);

  const items: Item[] = [{}];

  if (location[1] === "groups" && Preload && Preload.my_groups) {
    const groupSlug = location[2];
    const group = find(Preload.my_groups, { slug: location[2] });
    module = getModule(location[3]);

    if (group) {
      items.unshift({
        parentName: group.name,
        groupSlug,
      });

      if (includes(MODULE_WHITELIST, module)) {
        items.unshift({
          parentName: group.name,
          module,
          groupSlug,
        });
      }
    }
  } else {
    if (includes(MODULE_WHITELIST, module)) {
      items.unshift({ module });
    }
  }

  return items;
}
